import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
import { ArticleHeader } from "@cinch-nx/landing-ui-articles";
import { Head } from "@cinch-nx/landing-ui-shared";
import { Wrapper } from "@cinch-nx/shared-ui";
import styles from "./articles-sub-hub.module.css";
import { ArticlesCardsList, Pagination } from "./components";
export function ArticleSubHubFeature({ story , path , preview , generatedAt , currentPage , numberOfArticles , resultsPerPage , articles  }) {
    const { content  } = useStoryblokState({
        story,
        enableBridge: preview
    });
    const { title , description  } = content ?? {
        title: "Loading",
        description: "Loading..."
    };
    const [SEO] = (content === null || content === void 0 ? void 0 : content.SEO) ?? [
        {}
    ];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "Cars Without The Faff - cinch",
                fallbackDescription: "Welcome to cinch, the faff free way to buy & sell cars. We have thousands of used cars, ready to be sold to you."
            }),
            /*#__PURE__*/ _jsx("article", {
                className: styles.page,
                "data-testid": `articles-sub-hub-${path}`,
                children: /*#__PURE__*/ _jsxs(Wrapper, {
                    isSlim: true,
                    children: [
                        /*#__PURE__*/ _jsx(ArticleHeader, {
                            title: title,
                            subTitle: description
                        }),
                        /*#__PURE__*/ _jsx(ArticlesCardsList, {
                            path: path,
                            articles: articles,
                            page: currentPage
                        }),
                        /*#__PURE__*/ _jsx(Pagination, {
                            path: path,
                            currentPage: currentPage,
                            total: numberOfArticles,
                            resultsPerPage: resultsPerPage
                        })
                    ]
                })
            })
        ]
    });
}
